<template>
    <nav class="flex" aria-label="Breadcrumb">
        <ol role="list" class="flex items-center space-x-4">
            <li v-for="(crumb, i) in crumbs">
                <div class="flex items-center">
                    <svg v-if="i" class="flex-shrink-0 w-5 h-5 text-gray-500" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20" aria-hidden="true">
                        <path d="M5.555 17.776l8-16 .894.448-8 16-.894-.448z" />
                    </svg>
                    <Link :href="crumb.href" :class="{ 'ml-4': i }" class="hover:text-blue-700 text-gray-700 text-sm font-medium">{{ crumb.text | trim(55) }}</Link>
                </div>
            </li>
        </ol>
    </nav>
</template>

<script>
export default {
    props: {
        crumbs: {
            required: true,
            type: Array,
        },
    },

    computed: {
        crumbCount() {
            return this.crumbs.length
        },
    },
}
</script>
